import React, { CSSProperties } from "react";

import "./styles.scss";
import RadioButton from "common/components/RadioButton";

interface Props {
  label: string;
  img: any;
  backgroudContainer?: string;
  backgroudWrapper?: string;
  style?: CSSProperties | undefined;
  isActive: boolean;
  colorText?: string;
  onClick?: () => void;
}

const SettingsItem = ({
  label,
  img,
  backgroudContainer = "#481EA0",
  backgroudWrapper,
  style,
  isActive,
  onClick,
  colorText
}: Props) => {
  return (
    <div className="wrapper-settings-item" style={style} onClick={onClick}>
      <RadioButton active={isActive} />
      <div
        className="wrapper-settings-item-border"
        style={{ background: backgroudWrapper, padding: backgroudWrapper ? 2.5 : 0 }}>
        <div
          className="container-settings-item"
          style={{ background: backgroudContainer, borderRadius: backgroudWrapper ? 4 : 8 }}>
          <img src={img} />
          <span className="container-settings-item-label" style={{ color: colorText }}>
            {label}
          </span>
        </div>
      </div>
    </div>
  );
};

export default SettingsItem;
